import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE = import.meta.env.VITE_BACKEND_URL || "http://localhost:3000";

// Fetch all return tickets
export const fetchReturnTickets = createAsyncThunk(
  "adminReturns/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      console.log("Fetching return tickets from:", `${API_BASE}/api/admin/returns`);
      
      const { data } = await axios.get(`${API_BASE}/api/admin/returns`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      });
      
      console.log("Fetched returns:", data);
      return data;
    } catch (error) {
      console.error("Failed to fetch returns:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch return tickets"
      );
    }
  }
);

// Update return ticket - NOW INCLUDES ALL FIELDS
export const updateReturnTicket = createAsyncThunk(
  "adminReturns/update",
  async (updateData, { rejectWithValue }) => {
    try {
      const { id, ...fieldsToUpdate } = updateData;
      
      console.log(`Updating return ${id}`);
      console.log("Fields to update:", fieldsToUpdate);
      
      const { data } = await axios.put(
        `${API_BASE}/api/admin/returns/${id}`,
        fieldsToUpdate, // Send all fields in updateData
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );
      
      console.log("Updated return:", data);
      return data;
    } catch (error) {
      console.error("Failed to update return:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update return ticket"
      );
    }
  }
);

// Delete return ticket
export const deleteReturnTicket = createAsyncThunk(
  "adminReturns/delete",
  async (id, { rejectWithValue }) => {
    try {
      console.log(`Deleting return ${id}`);
      
      await axios.delete(`${API_BASE}/api/admin/returns/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      });
      
      console.log("Deleted return:", id);
      return id;
    } catch (error) {
      console.error("Failed to delete return:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete return ticket"
      );
    }
  }
);

const adminReturnSlice = createSlice({
  name: "adminReturns",
  initialState: {
    tickets: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch returns
      .addCase(fetchReturnTickets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReturnTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(fetchReturnTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Update return
      .addCase(updateReturnTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateReturnTicket.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.tickets.findIndex(
          (t) => t._id === action.payload._id
        );
        if (index !== -1) {
          state.tickets[index] = action.payload;
        }
      })
      .addCase(updateReturnTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Delete return
      .addCase(deleteReturnTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteReturnTicket.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = state.tickets.filter((t) => t._id !== action.payload);
      })
      .addCase(deleteReturnTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = adminReturnSlice.actions;
export default adminReturnSlice.reducer;
